import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { SiteService } from './site.service';

export const siteInterceptor: HttpInterceptorFn = (req, next) => {
  const siteService = inject(SiteService);
  const siteId = siteService.currentSiteId();

  if (siteId) {
    const siteReq = req.clone({
      setHeaders: { 'X-Site-Id': String(siteId) },
    });
    return next(siteReq);
  }

  return next(req);
};
